import { FC } from 'react';

import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { required } from '@utils/validators';
import { guestSelectors } from '@store/guest/selectors';
import { GuestDetails } from './GuestDetails';

const validate = (values) => {
  const errors: any = {};

  if (!values.guests || !values.guests.length) {
    errors.guests = {
      _error: required(),
    };
  } else {
    const guestArrayErrors: {}[] = [];
    values.guests.forEach((guest, guestIndex) => {
      const singleMemberErrors: {
        title?: string;
        firstName?: string;
        lastName?: string;
        gender?: string;
      } = {};
      singleMemberErrors.title = required(guest.title);
      singleMemberErrors.firstName = required(guest.firstName);
      singleMemberErrors.lastName = required(guest.lastName);
      singleMemberErrors.gender = required(guest.gender);
      guestArrayErrors[guestIndex] = singleMemberErrors;
    });
    if (guestArrayErrors.length) {
      errors.guests = guestArrayErrors;
    }
  }

  return errors;
};

const selector = formValueSelector('spaEntityConfigurationForm');

const mapStateToProps = (state) => ({
  guest: guestSelectors.getGuest(state),
  selectedArrivalTime: selector(state, 'arrivalTime'),
  selectedGuests: selector(state, 'guests'),
});

const GuestDetailsReduxForm = reduxForm({
  form: 'spaEntityConfigurationForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(GuestDetails as FC);

export const GuestDetailsConnected: any = connect(mapStateToProps)(GuestDetailsReduxForm);
